export enum Size {
  NANO = 8,
  MICRO = 16,
  TINY = 24,
  SMALL = 32,
  MEDIUM = 48,
  BIG = 64,
  LARGE = 128,
  HUGE = 256,
  MASSIVE = 512,
  GARGANTUAN = 1024,
}
